import { AfterViewInit, ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { Observable, of, Subject } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';
import { LongRunningContextCategoryTyp } from '../../../../samwebDescription/samweb/waitingContext/waitingContextCategory';
import { LongRunningContextState } from '../../../../store/server-communication/running-actions/long-running-context.state';

@Component({
   selector: 'samweb-loading-indicator',
   templateUrl: './loading-indicator.component.html',
   styleUrls: ['./loading-indicator.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingIndicatorComponent implements OnInit, AfterViewInit, OnDestroy {
   private destroy$ = new Subject();

   @Input()
   public longRunningContextCategories: string[];

   @Input()
   public showForAllLongRunningContextCategories: boolean;

   @Input()
   public brickInstanceId: string;

   @Input()
   public formGroupsToHandle: FormGroup[];

   @Input()
   public isLoading$: Observable<boolean>;

   @Input()
   public indicatorOnTop = false;

   @Input()
   // just for debugging. Loading indicator never stops running
   public runForever = false;

   @Input()
   public showLoadingCircle = false;

   constructor(private store: Store) {}

   ngOnInit() {
      if (_.isNil(this.isLoading$)) {
         if (this.runForever) {
            this.isLoading$ = of(true);
         } else if (this.showForAllLongRunningContextCategories && _.isNil(this.brickInstanceId)) {
            this.isLoading$ = this.store.select(LongRunningContextState.isAnyLongRunningContextInProgress);
         } else if (this.showForAllLongRunningContextCategories) {
            this.isLoading$ = this.store
               .select(LongRunningContextState.isAnyLongRunningContextInProgressForBrickId)
               .pipe(map((filterFn) => filterFn(this.brickInstanceId)));
         } else {
            this.isLoading$ = this.store.select(LongRunningContextState.isLongRunningContextInProgressForCategories).pipe(
               map((filterFn) =>
                  filterFn(
                     _(this.longRunningContextCategories)
                        .map((x) => LongRunningContextCategoryTyp.valueByName(x))
                        .value(),
                     this.brickInstanceId
                  )
               )
            );
         }
      }
   }

   ngAfterViewInit(): void {
      if (_.isEmpty(this.formGroupsToHandle)) {
         return;
      }
      this.isLoading$
         .pipe(
            tap((isLoading) => _.forEach(this.formGroupsToHandle, (x) => (isLoading ? x.disable() : x.enable()))),
            takeUntil(this.destroy$)
         )
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }
}
